import './MoveToStepButton.scss'
import React from 'react'
import Store from 'state/Store';
import { setStep } from 'state/steps/StepActions';
import { number } from 'prop-types';
import { LFEBeaconButton } from 'components/shared/LFEBeaconComponents';

const MoveToStepButton = ({ step }) =>{
  return(
      // <button className="edit-button"
      //         onClick={()=>Store.dispatch(setStep(step))}>Edit</button>
      <LFEBeaconButton className="edit-button"
                       linkTarget="_blank"
                       variant={'tertiary'}
                       label={'Edit'}
                       scale={'normal'}
                       onBeaconClick={()=>Store.dispatch(setStep(step))}
    />     
              
  )
}

MoveToStepButton.prototype = {
  step: number.isRequired,
}

MoveToStepButton.defaultProps = {
  step: 0,
}

export default MoveToStepButton